import { render, staticRenderFns } from "./ClinicSocialsV2.vue?vue&type=template&id=cf1e0d92&scoped=true"
import script from "./ClinicSocialsV2.vue?vue&type=script&lang=js"
export * from "./ClinicSocialsV2.vue?vue&type=script&lang=js"
import style0 from "./ClinicSocialsV2.vue?vue&type=style&index=0&id=cf1e0d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1e0d92",
  null
  
)

export default component.exports